import { createElement, useEffect, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Icon from '@max/leez-icon';
import useCountDown from '@hfe/max-use-countdown';
import './index.scss';
const ActivityCountdown = ({ appointmentTime, onCountdownEnd, fontColor = '#ffffff' }) => {
    var _a, _b, _c;
    if (!appointmentTime) {
        return null;
    }
    const now = Date.now();
    const isCountdownEnded = appointmentTime < now;
    // 防御：如果倒计时已结束，在最开始触发回调
    const hasTriggeredRef = useRef(false);
    useEffect(() => {
        if (isCountdownEnded && !hasTriggeredRef.current && onCountdownEnd) {
            hasTriggeredRef.current = true;
            onCountdownEnd();
        }
    }, [isCountdownEnded, onCountdownEnd]);
    // ✅ 倒计时未结束时调用 useCountDown，倒计时已结束时传入虚拟值保持 hook 调用一致
    // useCountDown 要求 startTime > endTime
    const countdownData = useCountDown(isCountdownEnded ? now + 1 : appointmentTime, now);
    // 计算时间差
    let days = 0, hours = 0, minutes = 0, seconds = 0;
    if (!isCountdownEnded && countdownData) {
        // 倒计时未结束，从 useCountDown 获取数据
        const totalSeconds = Math.floor((appointmentTime - now) / 1000);
        days = Math.floor(totalSeconds / 86400);
        hours = (_a = countdownData.hours) !== null && _a !== void 0 ? _a : 0;
        minutes = (_b = countdownData.minutes) !== null && _b !== void 0 ? _b : 0;
        seconds = (_c = countdownData.seconds) !== null && _c !== void 0 ? _c : 0;
    }
    // 倒计时已结束时，days, hours, minutes, seconds 保持初始值 0
    const formatTime = (time) => String(Math.max(0, time)).padStart(2, '0');
    return <View className="activity-countdown-container">
      <Icon name='history-line-regular' type='title2' iconFontType='meishi' nopaddingMode style={{
        marginRight: '6rpx',
        color: `${fontColor}`
    }}/>
      <Text className="activity-countdown-text" style={{
        color: `${fontColor}`
    }}>
        
        {`${days}天 `}
        {formatTime(hours)}:
        {formatTime(minutes)}:{formatTime(seconds)}
        {' 后可抢'}
      </Text>
    </View>;
};
export default ActivityCountdown;
